import { renderLocaleContent } from "@/app/[lang]/_utils/render-locale-content";
import type { Lang } from "@/langs";

export function createT<
  T extends Record<string, Record<Exclude<Lang, "en">, string>>,
>(dictionary: T) {
  function t(
    key: keyof T & string,
    lang: Lang,
    isStringOnly: true,
    dynamicTexts?: Record<string, string>,
    preserveMarks?: boolean,
  ): string;
  function t(
    key: keyof T & string,
    lang: Lang,
    isStringOnly?: boolean,
    dynamicTexts?: Record<string, string | React.ReactNode>,
    preserveMarks?: boolean,
  ): string | React.ReactElement;
  function t(
    key: keyof T & string,
    lang: Lang,
    isStringOnly?: boolean,
    dynamicTexts?: Record<string, string | React.ReactNode>,
    preserveMarks?: boolean,
  ): string | React.ReactElement {
    return renderLocaleContent(
      dictionary,
      key,
      lang,
      isStringOnly,
      dynamicTexts,
      preserveMarks,
    );
  }

  return t;
}
